import { List } from "antd-mobile";

export default List;
